<template>
  <div class="group-455">
    <img
      class="star-12"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/star-12-6.svg"
      alt="Star 12"
    />
    <img
      class="star-11"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/star-11-6.svg"
      alt="Star 11"
    />
    <img
      class="star-10"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/star-10-6.svg"
      alt="Star 10"
    />
    <img
      class="star-9"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/star-9-6.svg"
      alt="Star 9"
    />
    <img
      class="star-8"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d960dd33287fc8c76d6b57/img/star-8-6.svg"
      alt="Star 8"
    />
  </div>
</template>

<script>
export default {
  name: "Group455",
};
</script>

<style>
.group-455 {
  display: flex;
  height: 30px;
  left: 316px;
  position: absolute;
  top: 287px;
  width: 165px;
}

.star-12 {
  height: 27.14px;
  margin-left: 0.7px;
  width: 28.62px;
}

.star-11 {
  height: 27.14px;
  margin-left: 5.6px;
  width: 27.63px;
}

.star-10 {
  height: 27.14px;
  margin-left: 6.6px;
  width: 28.62px;
}

.star-9 {
  height: 27.14px;
  margin-left: 2.5px;
  width: 28.62px;
}

.star-8 {
  height: 27.14px;
  margin-left: 6.7px;
  width: 28.62px;
}
</style>
